import { Reducer } from 'redux'
import { ServpackActionTypes, ServpackState } from './type'

const initialState: ServpackState = {
  servpacking: {}
}

const reducer: Reducer<ServpackState> = (state = initialState, action) => {
  switch (action.type) {
    case ServpackActionTypes.USE_SERVPACK: {
      const { data } = action;
      return {
        ...state,
        servpacking: data
      }
    }
    default: {
      return state
    }
  }
}

export { reducer as ServpackReducer };